import React, { useEffect, useState } from 'react';
import { Divider } from 'wix-ui-tpa';
import ItemGenerator from './ItemGenerator/ItemGenerator';
import {
  st as dividerStyle,
  classes,
} from '../../../../../Shared/SharedDivider.st.css';
import {
  classes as itemWrapperClasses,
  style as st,
} from './ItemWrapper.st.css';
import useObservable from '../../../../../../Shared/Hooks/useObservable.Hook';
import { getSelectedItems } from '../../../../../Services/SelectedItems.service';
import { getAppSettings } from '../../../../../Services/AppSettings.service';
import { getTableSettings } from '../../../../../Services/TableSettings.service';
import { TableColumns } from '../../../../../../Constants/TableHeader.Constants';
import { useAppContext } from '../../../../../Shared/AppContext';

const ItemWrapper = (props: any) => {
  const {
    item,
    setHoveredOrSelectedItems,
    hoveredOrSelectedItems,
    getPreviousItems,
    index,
  } = props;
  const { compId } = useAppContext();
  const [state, setState] = useState<any>({
    selectedItems: [],
  });

  const [, selectedItems]: any = useObservable(getSelectedItems(compId));
  const [, appSettings]: any = useObservable(getAppSettings());
  const [, tableDisplaySettings]: any = useObservable(getTableSettings(compId));
  const displaySearch =
    tableDisplaySettings &&
    tableDisplaySettings.find(
      (data: any) => data.id === TableColumns.SEARCH_BAR,
    );
  const isMobile = appSettings !== undefined ? appSettings?.isMobile : '';
  const isEditorX: boolean =
    appSettings !== undefined ? appSettings.isEditor_X : false;
  const showTopDivider = isMobile
    ? !displaySearch?.value || (selectedItems && selectedItems.length > 0)
    : true;
  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      let tempSelectedItems: any = [];
      const previousSelectedItem = getPreviousItems(selectedItems);
      tempSelectedItems = [...previousSelectedItem, ...selectedItems];
      setState((prev: any) => ({
        ...prev,
        selectedItems: tempSelectedItems,
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        selectedItems: [],
      }));
    }
  }, [selectedItems]);

  return (
    <div
      onMouseEnter={() => {
        setHoveredOrSelectedItems('MouseEnter', item.id);
      }}
      onMouseLeave={() => {
        setHoveredOrSelectedItems('MouseLeave', item.id);
      }}
    >
      <div
        className={st(
          itemWrapperClasses.root,
          { checked: selectedItems && selectedItems.includes(item.id) },
          itemWrapperClasses.itemWrapperGeneratorContainer,
        )}
      >
        {index === 0 && showTopDivider ? (
          <div>
            <Divider
              className={
                hoveredOrSelectedItems.includes(item.id) ||
                (state.selectedItems && state.selectedItems.includes(item.id))
                  ? classes.dividerStyleHoverOrSelected
                  : dividerStyle(classes.dividerStyle, { isEditorX, isMobile })
              }
            />
          </div>
        ) : null}
        <ItemGenerator item={item} />
      </div>
      <div className={classes.dividerContainer}>
        <Divider
          className={
            hoveredOrSelectedItems.includes(item.id) ||
            (state.selectedItems && state.selectedItems.includes(item.id))
              ? classes.dividerStyleHoverOrSelected
              : dividerStyle(classes.dividerStyle, { isEditorX, isMobile })
          }
        />
      </div>
    </div>
  );
};

export default ItemWrapper;
